import { useEffect, useRef } from 'react';

export default function Cursor() {
  const dotRef  = useRef(null);
  const ringRef = useRef(null);
  const mouse   = useRef({ x: -200, y: -200 });
  const ring    = useRef({ x: -200, y: -200 });
  const raf     = useRef(null);

  useEffect(() => {
    // Hide on touch devices
    if (window.matchMedia('(hover: none)').matches) return;

    const onMove = (e) => { mouse.current = { x: e.clientX, y: e.clientY }; };
    window.addEventListener('mousemove', onMove);

    const animate = () => {
      ring.current.x += (mouse.current.x - ring.current.x) * 0.12;
      ring.current.y += (mouse.current.y - ring.current.y) * 0.12;
      if (dotRef.current)  dotRef.current.style.transform  = `translate(${mouse.current.x - 5}px, ${mouse.current.y - 5}px)`;
      if (ringRef.current) ringRef.current.style.transform = `translate(${ring.current.x - 17}px, ${ring.current.y - 17}px)`;
      raf.current = requestAnimationFrame(animate);
    };
    raf.current = requestAnimationFrame(animate);

    const expand = () => { if(ringRef.current){ ringRef.current.style.width='44px';ringRef.current.style.height='44px';ringRef.current.style.borderColor='#00D8FF';ringRef.current.style.opacity='.7'; } };
    const shrink = () => { if(ringRef.current){ ringRef.current.style.width='34px';ringRef.current.style.height='34px';ringRef.current.style.borderColor='#FF9900';ringRef.current.style.opacity='.45'; } };

    const attach = () => document.querySelectorAll('a,button,[role="button"]').forEach(el => { el.addEventListener('mouseenter',expand); el.addEventListener('mouseleave',shrink); });
    attach();
    const obs = new MutationObserver(attach);
    obs.observe(document.body, { childList:true, subtree:true });

    return () => { window.removeEventListener('mousemove', onMove); cancelAnimationFrame(raf.current); obs.disconnect(); };
  }, []);

  return (
    <>
      <div ref={dotRef}  className="fixed w-2.5 h-2.5 bg-aws rounded-full pointer-events-none z-[9999] top-0 left-0 mix-blend-difference will-change-transform" />
      <div ref={ringRef} className="fixed w-[34px] h-[34px] border-[1.5px] border-aws rounded-full pointer-events-none z-[9998] top-0 left-0 opacity-[.45] will-change-transform transition-[width,height,border-color,opacity] duration-250" />
    </>
  );
}
